module.exports = {
  "wxc-index-list": {
    "position": "relative"
  },
  "index-list": {
    "width": 750,
    "height": 1334
  },
  "index-list-title": {
    "borderBottomWidth": 1,
    "borderColor": "rgba(32,35,37,0.15)",
    "backgroundColor": "#FBFBFB",
    "fontSize": 24,
    "color": "#666666",
    "paddingBottom": 14,
    "paddingTop": 14,
    "paddingLeft": 23,
    "width": 750
  },
  "group-title": {
    "borderBottomWidth": 0,
    "paddingBottom": 0,
    "paddingTop": 24
  },
  "index-list-item": {
    "width": 750,
    "flexDirection": "row",
    "alignItems": "center",
    "borderBottomWidth": 1,
    "borderBottomColor": "#e0e0e0",
    "height": 92,
    "paddingLeft": 24,
    "paddingRight": 24,
    "backgroundColor": "#FFFFFF"
  },
  "title": {
    "fontSize": 32,
    "color": "#3D3D3D"
  },
  "desc": {
    "fontSize": 24,
    "color": "#A5A5A5",
    "marginLeft": 30
  },
  "index-list-nav": {
    "position": "absolute",
    "top": 0,
    "right": 0,
    "marginBottom": 60,
    "marginTop": 60,
    "paddingBottom": 20,
    "paddingTop": 20,
    "width": 70
  },
  "list-nav-key": {
    "textAlign": "center",
    "fontSize": 24,
    "height": 40,
    "color": "#666666"
  },
  "index-list-pop": {
    "position": "fixed",
    "top": 550,
    "left": 316,
    "width": 118,
    "height": 118,
    "textAlign": "center",
    "justifyContent": "center",
    "backgroundColor": "rgba(32,35,37,0.6)",
    "borderRadius": 59,
    "paddingLeft": 0,
    "paddingRight": 0,
    "paddingTop": 35,
    "paddingBottom": 35,
    "color": "#ffffff",
    "opacity": 1
  },
  "list-pop-text": {
    "fontSize": 40,
    "textAlign": "center",
    "color": "#ffffff"
  },
  "group": {
    "paddingBottom": 18,
    "paddingRight": 70,
    "backgroundColor": "#FBFBFB"
  },
  "group-list": {
    "flexDirection": "row",
    "marginLeft": 18,
    "marginTop": 18,
    "backgroundColor": "#FBFBFB"
  },
  "group-item": {
    "width": 146,
    "height": 64,
    "borderWidth": 1,
    "borderColor": "#e0e0e0",
    "marginRight": 18,
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "backgroundColor": "#FFFFFF"
  },
  "item-content": {
    "flexDirection": "column"
  },
  "item-name": {
    "fontSize": 24,
    "lineHeight": 26,
    "color": "#333333"
  },
  "item-desc": {
    "marginTop": 2,
    "color": "#999999",
    "fontSize": 20,
    "textAlign": "center"
  },
  "location-icon": {
    "width": 32,
    "height": 32,
    "marginRight": 8
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-9a82c098!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-indexlist/index.vue
// module id = 65
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28